// eslint-disable-next-line import/no-anonymous-default-export
export default {
  translations: {
    insurance: 'Asigurare',
    tourist_insurance: 'Asigurare turistica',
    step_1: 'Introduceți detaliile călătoriei dvs',
    step_2: 'Alege cea mai buna oferta',
    step_3: 'Introduceți datele dvs. personale',
    step_4: 'Plătiți și primiți polița prin e-mail',
    date_from: 'Început',
    date_to: 'Sfârșit',
    back_to: "Înapoi",
    where_to_go: 'Unde mergeți?',
    when_to_go: 'Data călătoriei',
    who_to_go: 'Numărul de turiști',
    select_country: 'Alegeți țară',
    add_tourist: '+ Adăugați un alt turist',
    tourist: 'Turist',
    delete: 'Sterge',
    birth_date: 'Data nasterii',
    all_insurance: 'Arata toate propunerile',
    rules: 'Reguli',
    user_agreement: 'Termenii și condițiile de utilizare',
    user_policy: 'Politica de confidențialitate',
    contacts: 'Contacte',
    social_networks: 'Social',
    company: 'Companie',
    insurance_summ: 'Suma asigurată',
    price: 'Preț',
    options: 'opții',
    covid_coverage:
      'Acoperă riscurile legate de tratamentul infecției cu coronavirus (COVID-19)',
    buy_for: 'Cumpără cu',
    details: 'Termeni și condiții detaliate',
    form_insurance: 'Emiterea poliței de asigurare',
    selected_country: 'Țara în care se călătorește',
    from: 'de pe',
    to: 'pina pe',
    insurance_offer_notification:
      'Polița poate fi emisă doar înainte de călătorie',
    insurance_price: 'Prețul poliței de asigurare',
    name: 'Prenume*',
    surname: 'Nume*',
    idnp: 'IDNP*',
    passportNumber: 'Seria și numărul pașaportului*',
    phoneNumber: 'Telefon',
    enter_idnp: 'Exemplu: 1236548962364258. Max. 13 simboluri.',
    enter_passportNumber: 'Exemplu: B1256326',
    enter_phoneNumber: 'Exemplu: +373 (00) 00 00 00 ',
    rules_block_title:
      'Confirm că, la momentul procurării asigurării de sănătate, persoana asigurată:',
    rules_block_1: 'Are permis de ședere în Republica Moldova;',
    rules_block_2:
      'Nu călătorește într-o țară în care își are reședința permanentă sau a cărei cetățenie o deține;',
    rules_block_3:
      'Nu a avut niciun eveniment asigurat care a dus la afectarea sănătății (traume, accidente etc.) înainte de perioada de asigurare;',
    rules_block_4:
      'Nu urmează și nu intenționează să urmeze un tratament medical în timpul perioadei de asigurare;',
    rules_block_5:
      'Nu abuzează de medicamente sau de alte substanțe interzise;',
    rules_block_6:
      'Nu intenționează să călătorească pentru a participa la sporturi extreme fără un certificat special;',
    rules_block_7:
      'Nu intenționează să călătorească în țări nerecomandate de Ministerul Afacerilor Externe.',
    rules_block_8:
      'Am citit Condițiile speciale ale asigurării de sănătate pentru călătorii în străinătate, care fac parte integrantă din contractul de asigurare, și sunt de acord cu prevederile acestora.',
    rules_block_9:
      'Asigurătorul nu răspunde pentru evenimentele asigurate care se produc înainte și după încheierea perioadei de asigurare specificate în contract. Am fost informat/informată de către Asigurător și sunt de acord că, dacă persoana/persoanele care urmează să fie asigurate se află în străinătate la momentul încheierii contractului, acoperirea asigurării începe după 5 zile de la data semnării/confirmării contractului.',
    rules_block_10:
      'Totodată, în calitate de titular de poliță (persoană asigurată, după caz), îmi dau acordul pentru prelucrarea datelor cu caracter personal, specificate în prezenta cerere, de către asigurător/reprezentantul legal, în conformitate cu prevederile Legii privind protecția datelor cu caracter personal, inclusiv în cazul unei investigații privind daunele, și declar că am acordul celorlalte persoane care fac obiectul asigurării în temeiul prezentei cereri de asigurare pentru furnizarea datelor lor cu caracter personal.',
    hide_rules: 'Ascunde textul',
    show_rules: 'Arata tot',
    continue: 'Continuă',
    total: 'Total',
    description_title: 'Ce trebuie să știi despre asigurarea de călătorie?',
    description_1_title_blue: 'De ce ai nevoie ',
    description_1_title: 'de asigurare de călătorie?',
    description_1_text1:
      'Asigurarea de călătorie este o formă voluntară de asigurare. Subliniem că, pentru a trece hotarele multor țări, polița de asigurare de călătorie este o condiție prealabilă. Poliță de asigurare de călătorie vă poate proteja împotriva multor situații neprevăzute în timpul vacanței.',
    description_1_text2:
      'Această protecție este prevăzută într-un document special de asigurare - polița de asigurare peste hotare. Anume acest document stabilește condițiile și cuantumurile compensațiilor pentru asigurat în cazul producerii unui eveniment asigurat.',
    description_2_title_blue: 'Ce riscuri ',
    description_2_title: 'acoperă asigurarea de călătorie?',
    description_2_text1:
      'Polița de asigurare de bază acoperă doar principalele riscuri:',

    description_2_text2: 'tratament de urgență în ambulatoriu și în staționar,',
    description_2_text3:
      'tratamente stomatologice și chirurgicale și transportul aferent,',
    description_2_text4: 'chemarea medicului,',
    description_2_text5:
      'achitarea medicamentelor și a cheltuielilor de tratament',
    description_2_text6: 'evacuarea în țara de origine din motive de sănătate.',
    description_2_text7:
      'În cadrul asigurării standard nu puteți obține despăgubiri în caz de refuz al vizei, anulare a zborului, pierdere a bagajelor sau accidentare sportivă. În astfel de situații, veți avea nevoie de o poliță de asigurare peste hotare suplimentară.',
    description_3_title_blue: 'să refuze rambursarea cheltuielilor medicale?',
    description_3_title: 'Poate compania de asigurări ',
    description_3_text1:
      'Polița nu acoperă accidentele cauzate de aflarea Asiguratului sub influența alcoolului sau a drogurilor, cazurile legate de gestionarea și evoluția sarcinii (cu excepția sarcinilor ectopice) sau a bolilor psihice.',
    description_3_text2:
      'Chirurgia plastică și reconstructivă și protezele nu sunt acoperite. Pentru o listă completă a excluderilor, a se consulta Termenii și condițiile de asigurare.',
    description_4_title_blue:
      'în cazul în care se produce un eveniment asigurat?',
    description_4_title: 'Ce trebuie făcut ',
    description_4_text1:
      'Contactează în orice mod operatorul de servicii pentru clienți. Toate persoanele de contact sunt indicate în polița de asigurare.',
    description_4_text2:
      'Spune operatorului numărul poliței de asigurare peste hotare și descrie pe scurt asistența de care este nevoie. Specialistul va chema un medic sau îți va da adresa celei mai apropiate clinici.',
    description_4_text3:
      'Urmează strict instrucțiunile operatorului. Nu plăti factura singur: Compania de asigurări va rambursa cheltuielile',
    description_4_text4:
      'Dacă mergi la clinică fără să apelezi la furnizorul de servicii, ai grijă cum completezi documentele financiare. În termen de 30 de zile furnizează dovada cheltuielilor către compania de asigurări.',
    description_4_text5:
      'Vom lua o decizie de rambursare în termen de câteva zile de la depunerea cererii.',
    success_title: 'Îți urăm călătorie plăcută!',
    success_desc:
      'Polița a fost trimisă la adresa de e-mail example@gmail.com.În 5 minute veți primi polița în format de document PDF.',
    success_button: 'Descarcă polița de asigurare acum',
    fail_title: 'Eroare la plată',
    fail_desc:
      'Dacă nu ai reușit să plătești asigurarea, te rugăm să încerci din nou sau să contactezi banca.',
    fail_button: 'Încearcă din nou',
    confirm_order: 'Confirmarea datelor',
    insuranse_info_send:
      'Polița se plătește online și se trimite momentan prin e-mail în format PDF',
    confirm_personal:
      'Sunt de acord cu prelucrarea datelor cu caracter personal, cu informația privind ',
    confirm_terms: 'termeni și condiții de utilizare',
    confirm_policy: 'politica de confidențialitate',
    on_site: ' de pe site.',   
    and: ' și ',    
    pay: 'Achită',
    assistans: 'Asistență',
    insurance_rules: 'Reguli de asigurare',
    insurance_policy: 'Exemplu de asigurare',
    ambulatory_treatment: 'Tratament ambulatoriu',
    doctor_call: 'Chemarea medicului',
    phone_expenses: 'Costuri telefonice',
    transportation_to_doctor: 'Transport la medic sau la spital',
    emergency_dentistry: 'Tratament dentar de urgență',
    emergency_medical_care: 'Tratament medical de urgență',
    medicines: 'Medicamente',
    accident: 'Accident',
    cover_covid_risks: 'Acoperă riscurile legate de tratamentul infecției cu coronavirus (COVID-19)',
    standard_options: 'Opțiuni standard',
    expenses_for_person: 'Сheltuieli pentru persoana de  însoțire',
    date_picker_place_holder: 'dd/mm/yyyy',
    enter_your_name: 'Indicați numele ca în buletin',
    enter_your_surname: 'Indicați familia ca în buletin',
    client_responsability: 'Clientul poartă răspundere pentru corectitudinea datelor indicate. Toate datele trebuie să corespundă cu cele din buletin. În caz contrar asigurarea va fi anulată.',
    consumer_information: 'Informație pentru consumători',
    terms_of_payment: 'Termeni de achitare și plăți',
    country: 'Țara de reședință*',
    city: 'Orașul de reședință*',
    work_days_hours: 'L - V 9:00-18:00',
    lunch_break: 'Pauză 13:00-14:00',
    juridical_address: 'Adresa juridică',   
  },
};
